import React from 'react';
import { useNavigate } from 'react-router-dom';

const UnAuthorize2 = () => {
    const navigate = useNavigate();

    return (
        <section className="min-h-[calc(100vh-0px)] bg-[#F2F7FA] px-[1rem] py-[2rem] fixed inset-0 z-[100000]">
            <div className="bg-white w-full h-full border border-[#E4E7EC] rounded-lg flex items-center justify-center min-h-[calc(100vh-4rem)]">
                <div className="max-w-screen-sm text-center">
                    <h1 className="mb-4 text-7xl mb-24 tracking-tight font-extrabold lg:text-9xl text-black">403</h1>
                    <p className="mb-4 text-3xl tracking-tight font-bold md:text-4xl text-black">You are not authorized.</p>
                    <p className="mb-4 text-lg font-light text-gray-500">Please contact your admin</p>

                    <button
                        type="button"
                        className="text-white text-center bg-[#167AC3] font-medium rounded-lg text-sm px-5 py-2.5 mb-2"
                        onClick={() => {
                            navigate('/');
                        }}
                    >
                        Back To Home
                    </button>
                </div>
            </div>
        </section>
    )
}

export default UnAuthorize2